<template>
  <v-btn icon color="blue darken-2" :disabled="toggleDisabled">
    <v-icon @click="toggleRow()">
      {{ toggleIcon(dynalabelItem) }}
    </v-icon>
  </v-btn>
</template>
<script>
export default {
  props: {
    dynalabelItem: {
      type: Object,
      required: true
    },
    toggleDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {},
  methods: {
    toggleIcon(item) {
      return item.expanded ? "mdi-chevron-down" : "mdi-chevron-right";
    },
    toggleRow() {
      this.$emit("toggleDynaExpand", { dynaItem: this.dynalabelItem });
    }
  },

  mounted() {},
  watch: {}
};
</script>

<style scoped></style>
